import script from "./ReferralsVisualisePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReferralsVisualisePage.vue?vue&type=script&setup=true&lang=ts"

import "./ReferralsVisualisePage.vue?vue&type=style&index=0&id=8c378fb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c378fb2"]])

export default __exports__